export const ACTIONS_ROUTE = 'actions';

export const SELECT_SIGNALS_ACTION_ROUTE = 'select-signals';
export const CREATE_LOCATION_ACTION_ROUTE = 'create-location';
